import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Plus, CaretDown, CaretRight, UsersThree, User } from "@phosphor-icons/react";
import { CreateBuddyDialog } from "@/components/CreateBuddyDialog";
import { BuddyList } from "@/components/BuddyList";
import { Shell } from "@/components/Shell";
import { useApp } from "@/context/AppContext";
import api from "@/lib/api";

export default function Tags() {
  const { t } = useApp();
  const [sections, setSections] = useState([]);
  const [createOpen, setCreateOpen] = useState(false);
  const [collapsed, setCollapsed] = useState({});

  const load = async () => setSections((await api.get("/tags/grouped")).data);
  useEffect(() => { load(); }, []);

  const toggle = (id) => setCollapsed((c) => ({ ...c, [id]: !c[id] }));
  const totalBuddies = sections.reduce((s, x) => s + x.buddies.length, 0);

  return (
    <Shell back="/dashboard">
      <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }}>
        <h1 className="text-3xl font-heading font-semibold text-gray-900">{t("tagsTitle")}</h1>

        <button data-testid="tags-create-buddy-btn" onClick={() => setCreateOpen(true)}
          className="sb-btn w-full py-3.5 mt-4 text-white font-medium flex items-center justify-center gap-2" style={{ background: "var(--app-primary)" }}>
          <Plus size={20} weight="bold" />{t("createBuddy")}
        </button>

        <div className="mt-6 space-y-5">
          {totalBuddies === 0 && sections.length <= 1 && (
            <p className="font-body text-gray-500" data-testid="no-tags">{t("noTags")}</p>
          )}
          {sections.map((sec) => {
            const isCol = !!collapsed[sec.group_id];
            const count = sec.buddies.length;
            return (
              <div key={`${sec.source}-${sec.group_id}`} data-testid={`buddy-section-${sec.group_id}`}>
                <button onClick={() => toggle(sec.group_id)} data-testid={`section-toggle-${sec.group_id}`}
                  className="w-full flex items-center gap-2 mb-2 text-left active:scale-[0.99] transition-transform">
                  {isCol ? <CaretRight size={18} weight="bold" className="text-gray-500" /> : <CaretDown size={18} weight="bold" className="text-gray-500" />}
                  {sec.source === "personal"
                    ? <User size={18} weight="duotone" style={{ color: "var(--app-strong)" }} />
                    : <UsersThree size={18} weight="duotone" style={{ color: "var(--app-strong)" }} />}
                  <span className="font-heading font-semibold text-lg">{sec.label}</span>
                  <span className="font-body text-xs text-gray-400">· {count}</span>
                  {!sec.editable && count > 0 && (
                    <span className="text-[10px] uppercase font-heading px-2 py-0.5 rounded-full bg-gray-200 text-gray-600" data-testid={`section-readonly-${sec.group_id}`}>Nur ansehen</span>
                  )}
                </button>
                {!isCol && (
                  count === 0
                    ? <p className="font-body text-sm text-gray-500 pl-6">{t("noTags")}</p>
                    : <BuddyList tags={sec.buddies} onChanged={load} canEdit={sec.editable} />
                )}
              </div>
            );
          })}
        </div>
      </motion.div>

      <CreateBuddyDialog open={createOpen} onOpenChange={setCreateOpen} onCreated={load} />
    </Shell>
  );
}
